import { render, staticRenderFns } from "./BaseSidebar.vue?vue&type=template&id=0c86ac63&scoped=true"
import script from "./BaseSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSidebar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseSidebar.vue?vue&type=style&index=0&id=0c86ac63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c86ac63",
  null
  
)

export default component.exports